<!-- routes/YukaEvent.svelte -->
<script>
  import { onMount } from "svelte";
  import TopWithVideo from '../components/events/yuka/TopWithVideo.svelte'
  import Apply from '../components/events/yuka/Apply.svelte'
  import Plan from '../components/events/yuka/Plan.svelte'
  import Price from '../components/events/yuka/Price.svelte'
  import AppIntro from '../components/events/yuka/AppIntro.svelte'
  import YukaIntro from '../components/events/yuka/YukaIntro.svelte'
  import Confused from '../components/events/yuka/Confused.svelte'
  import LevelUp from '../components/events/yuka/LevelUp.svelte'
  import YukaClassIntro from '../components/events/yuka/YukaClassIntro.svelte'

  import { userIP } from "../store/storeIP";

  let ipAddress;
  let userAgent
  const apiUrl = import.meta.env.API_URL || 'http://127.0.0.1/api/';

  userIP.subscribe(value => {
    ipAddress = value;
  });

  onMount(async () => {
    // 獲取瀏覽器資訊
    userAgent = navigator.userAgent;

    // 擷取User IP
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    userIP.set(data.ip);

    await recordUserInfo('Reach page');
  });

  // 記錄使用者資訊
  async function recordUserInfo(activeType) {
    const url = `${apiUrl}/log`
    const data = {
      ip: ipAddress,
      activeType: activeType,
      browser: userAgent
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      console.error('Network response was not ok', response);
      return;
    }

    /*
    const responseData = await response.json();
    console.log(responseData);
    */
  }

  // 監聽按下報名按鈕
  async function clickApplyFunction(event) {
    // 紀錄LOG
    await recordUserInfo('Clicked Apply');

    // 轉跳至付費頁面
    window.open(event.detail, '_self');
  }
</script>


<div>
  <TopWithVideo />
  <Apply on:applyClicked={clickApplyFunction}/>
  <Confused />
  <LevelUp />
  <Plan />
  <Price />
  <Apply on:applyClicked={clickApplyFunction}/>
  <AppIntro />
  <YukaClassIntro />
  <YukaIntro />
  <Apply on:applyClicked={clickApplyFunction}/>
</div>
